function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenericCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 80",
    width: "00px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-952.362)",
    style: {
      fill: "#999999"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14.583332,977.36199 c -2.308334,0 -4.166667,1.85833 -4.166667,4.16666 v 41.66665 c 0,2.3083 1.858333,4.1667 4.166667,4.1667 h 70.833333 c 2.30833,0 4.16667,-1.8584 4.16667,-4.1667 v -41.66665 c 0,-2.30833 -1.85834,-4.16666 -4.16667,-4.16666 z",
    id: "rect10401",
    style: {
      color: "#000000",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#999999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "26.66666603px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 23.251955,
    y: 54.86002,
    id: "text830"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan828",
    x: 23.251955,
    y: 54.86002,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "13.33333302px",
      fontFamily: "'Lohit Assamese'",
      InkscapeFontSpecification: "'Lohit Assamese Bold'",
      fill: "#ffffff"
    }
  }, "BRAND")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericCardIcon);
export default __webpack_public_path__ + "static/media/generic_card_icon.ecc3251a.svg";
export { ForwardRef as ReactComponent };